import React, { useState } from "react";
import { menuItemLeft, menuItemRight } from "../data/data";
import logoBrand from "../assets/main-logo-primary.png";
import "../App.scss";
import Hamburger from "./svgComponent/Hamburger";
import Close from "./svgComponent/Close";

const Navbar = () => {

  const [showSideBar, setShowSidebar] = useState(false);


  const sideNavbarHandler = ()=>{
    setShowSidebar(!showSideBar);
  }


  return (
    <>
      {/* Desktop - Navbar */}
      <nav className="navbar-desktop">
        <div className="container-navbar section-width">
          <ul className="menu-item-list__left p-0 m-0">
            {menuItemLeft.map((menuItemLeft) => {
              return (
                <li className="menu-item-list">
                  <a className="menu-item" href={menuItemLeft.navigateTo}>
                    {menuItemLeft.menuLable}
                  </a>
                </li>
              );
            })}
          </ul>
          <a className="navbar-brand" href="#home">
            <img
              src={logoBrand}
              className="brand-logo"
              alt="gayatri-home-tuition-logo"
            />
          </a>
          <ul className="menu-item-list__right p-0 m-0">
            {menuItemRight.map((menuItemRight) => {
              return (
                <li className="menu-item-list">
                  <a className="menu-item" href={menuItemRight.navigateTo}>
                    {menuItemRight.menuLable}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>

      {/* Mobile - Navbar */}
      <nav className="navbar-mobile">
        <div className="mobile-menu-fixed-bar">
          <button className="hanburger-menu-btn" onClick={sideNavbarHandler}>
            <Hamburger />
          </button>
          <a className="mobile-navbar-brand" href="#home">
            <img
              src={logoBrand}
              className="brand-logo"
              alt="gayatri-home-tuition-logo"
            />
          </a>
        </div>
      </nav>

      <div className={showSideBar ? "mobile-menu-list-wrapper" : "d-none"}>
      {/* <div className={"mobile-menu-list-wrapper hideSideBar"}> */}
        <div className="mobile-navbar-logo-fixed-top-part">
          <a className="mobile-navbar-brand" href="#home">
            <img
              src={logoBrand}
              className="brand-logo"
              alt="gayatri-home-tuition-logo"
            />
          </a>
          <button className="close-menu-btn" onClick={sideNavbarHandler}><Close /></button>
        </div>
        <hr />
        <ul className="mobile-menu-list">
          {menuItemLeft.map((menuItemLeft) => {
            return (
              <li className="mobile-menu-item-list" onClick={sideNavbarHandler}>
                <a className="mobile-menu-item" href={menuItemLeft.navigateTo}>
                  {menuItemLeft.menuLable} 
                </a>
              </li>
            );
          })}
          {menuItemRight.map((menuItemRight) => {
            return (
              <li className="mobile-menu-item-list" onClick={sideNavbarHandler}>
                <a className="mobile-menu-item" href={menuItemRight.navigateTo}>
                  {menuItemRight.menuLable}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};
export default Navbar;
